import { render, staticRenderFns } from "./Create-Review.vue?vue&type=template&id=4944b659&scoped=true"
import script from "./Create-Review.vue?vue&type=script&lang=js"
export * from "./Create-Review.vue?vue&type=script&lang=js"
import style0 from "./Create-Review.vue?vue&type=style&index=0&id=4944b659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944b659",
  null
  
)

export default component.exports